import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';

import { fetchBrandBasicList } from '@services/commonService';

const AddBrandPopup = ({ closeModal }) => {
	const [inputData, setInputData] = useState({});
	const [brands, setBrands] = useState([]);
	const [search, setSearch] = useState('');
	const navigate = useNavigate();

	const fetchBrandList = (params = '') => {
		fetchBrandBasicList(params).then((res) => {
			let tmpBrands = res.map((item) => ({ id: item.id, value: item.name }));
			setBrands(tmpBrands);
		});
	};

	useEffect(() => {
		fetchBrandList();
	}, []);

	const onBrandClick = (obj) => {
		setInputData({
			brand: obj
		});
		navigate(`/brand/profile/${obj.id}`);
	};

	return (
		<ModalContainer onCloseModal={closeModal} size="md" className="add-projection-modal">
			<div className="common-popup add-projection-modal shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Search Brand</h3>
					</div>
					<div className="close-btn" onClick={() => closeModal(false)}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="form-group ">
									<label htmlFor="brand-name">{''}</label>
									<CustomDropdown
										type="addItem"
										title={''}
										onItemClick={onBrandClick}
										items={brands}
										onItemSearch={(value) => {
											setSearch(value);
											fetchBrandList(`?name=${value}`);
										}}
										selectedItem={inputData?.brand?.value || ''}
										showAddNewButton={true}
										onAddNewButtonClick={() =>
											navigate(`/brands/add?name=${encodeURIComponent(search)}`)
										}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddBrandPopup;
